import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  BarChart3,
  Settings,
  Zap,
  LogOut,
  ChevronLeft,
  ChevronRight,
} from "../../utils/icons";
import Avatar from "../ui/Avatar";

const navItems = [
  { to: "/dashboard", icon: LayoutDashboard, label: "Overview", end: true },
  { to: "/dashboard/analytics", icon: BarChart3, label: "Analytics" },
  { to: "/dashboard/users", icon: Users, label: "Users" },
  { to: "/dashboard/settings", icon: Settings, label: "Settings" },
];

const Sidebar = ({ collapsed, onToggle }) => {
  const navigate = useNavigate();

  return (
    <aside
      className={`h-screen fixed top-0 left-0 z-30 flex flex-col bg-white dark:bg-gray-900 border-r border-gray-200 dark:border-gray-800 transition-all duration-300 ${collapsed ? "w-16" : "w-60"}`}
    >
      <div
        className={`flex items-center h-16 px-4 border-b border-gray-200 dark:border-gray-800 ${collapsed ? "justify-center" : "gap-2"}`}
      >
        <div className="w-8 h-8 bg-gradient-to-br from-primary-500 to-accent-500 rounded-lg flex items-center justify-center flex-shrink-0">
          <Zap size={16} className="text-white" />
        </div>
        {!collapsed && (
          <span className="font-display font-bold text-lg gradient-text">
            NexaFlow
          </span>
        )}
      </div>

      <nav className="flex-1 overflow-y-auto py-4 px-2 space-y-1">
        {navItems.map(({ to, icon: IconComp, label, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `sidebar-item ${isActive ? "active" : ""} ${collapsed ? "justify-center px-2" : ""}`
            }
          >
            <IconComp size={18} className="flex-shrink-0" />
            {!collapsed && <span>{label}</span>}
          </NavLink>
        ))}
      </nav>

      <div className="border-t border-gray-200 dark:border-gray-800 p-3 space-y-1">
        {!collapsed ? (
          <div className="flex items-center gap-3 px-2 py-2">
            <Avatar name="Aria Chen" size="sm" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-gray-900 dark:text-white truncate">
                Aria Chen
              </p>
              <p className="text-xs text-gray-500 truncate">Admin</p>
            </div>
          </div>
        ) : (
          <div className="flex justify-center py-1">
            <Avatar name="Aria Chen" size="sm" />
          </div>
        )}

        <button
          onClick={() => navigate("/login")}
          className={`sidebar-item w-full text-red-500 hover:text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 ${collapsed ? "justify-center px-2" : ""}`}
        >
          <LogOut size={18} />
          {!collapsed && <span>Logout</span>}
        </button>

        <button
          onClick={onToggle}
          className={`sidebar-item w-full ${collapsed ? "justify-center px-2" : ""}`}
        >
          {collapsed ? (
            <ChevronRight size={18} />
          ) : (
            <>
              <ChevronLeft size={18} />
              <span>Collapse</span>
            </>
          )}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
